import React from 'react';
import {connect} from 'react-redux';

import strings from 'utils/strings';
import byttelydAvatar from '../Tulleordtesten/assets/byttelyd.png';

import {
	goToNextStep,
	setTestStepAnswers,
	setIsSendingTestResultsToFalse,
} from 'actions/index';

import './styles.scss';

import {TEST_STEPS} from 'constants/index';

import Intro from './Intro';
import Test from './Test';
import Norming from './Norming';

const subSteps = [Intro, Test];
const subStepsNorming = [Intro, Norming];
class Orddiktat extends React.Component {
	constructor(props) {
		super(props);

		this.handleNextSubstep = this.handleNextSubstep.bind(this);

		this.state = {
			currentSubstepIndex: 0,
			isSubmitting: false,
			showAvatar: true,
		};

		this.audioRefs = {};
	}

	handleNextSubstep(results) {
		const {currentSubstepIndex} = this.state;
		const {candidateGrade, isDldTest} = this.props;

		const {
			onGoToNextStep,
			onSetTestStepAnswers,
			onSetIsSendingTestResultsToFalse,
		} = this.props;

		const isLastStep = currentSubstepIndex === subSteps.length - 1;

		if (isLastStep) {
			const resultKeys = Object.keys(results);
			const formattedResults = resultKeys.map((id, index) => {
				const value = results[id];
				return {
					id: isDldTest ? `${index + 1}` : id,
					value,
				};
			});
			onSetTestStepAnswers(
				TEST_STEPS.ORDDIKTAT,
				formattedResults,
				candidateGrade
			)
				.then(() => {
					if (!this.state.isSubmitting) {
						this.setState({isSubmitting: true});
						onSetIsSendingTestResultsToFalse();
						onGoToNextStep();
					}
				})
				.catch(() => {
					this.setState({isSubmitting: false});
				});
		} else {
			this.setState({
				currentSubstepIndex: currentSubstepIndex + 1,
			});
			setTimeout(() => {
				window.scrollTo(0, 0);
			});
		}
	}

	render() {
		const {currentSubstepIndex} = this.state;

		const CurrentSubStep = this.props.isDldTest ? subStepsNorming[currentSubstepIndex] : subSteps[currentSubstepIndex];

		return (
			<div className="lit-avatar-test">
				{this.state.showAvatar && (
					<div className="avatar-img">
						<img className="adminItem" src={byttelydAvatar} alt=""></img>
					</div>
				)}
				{currentSubstepIndex === 0 && (
					<h1 className="lit-page-title">{strings.orddiktat}</h1>
				)}
				<CurrentSubStep
					onNextStep={this.handleNextSubstep}
					onShowAvatar={(flag) => this.setState({showAvatar: flag})}
					refs={this.audioRefs}
					candidateGrade={this.props.candidateGrade}
					isDldTest={this.props.isDldTest}
				/>
			</div>
		);
	}
}

const mapStateToProps = (state) => {
	const {candidateGrade} = state;
	return {
		candidateGrade,
	};
};

const mapDispatchToProps = {
	onGoToNextStep: goToNextStep,
	onSetTestStepAnswers: setTestStepAnswers,
	onSetIsSendingTestResultsToFalse: setIsSendingTestResultsToFalse,
};

export default connect(mapStateToProps, mapDispatchToProps)(Orddiktat);
